import IntroBanner from "../../../components/intro-banner/intro-banner/intro-banner.component";
import "./privacy-policy-page.styles.css";

import ppImage from "../../../assets/images/about-us.jpg";

const PrivacyPolicyPage = () => {
  const ppTextData = [
    {
      title: "ثبت سفارش",
      content: "تمامی سفارش‌ها پس از پرداخت نهایی و تأیید، پردازش می‌شوند.",
    },
    {
      title: "ارسال و تحویل",
      content:
        "سفارش‌ها طی ۲ تا ۴ روز کاری ارسال می‌شوند. مشتری موظف است هنگام تحویل، کالا را بررسی کرده و در صورت وجود مشکل، سریعاً اطلاع دهد.",
    },
    {
      title: "مرجوعی و تعویض",
      content:
        "کالاها در صورت استفاده‌نشدن و حفظ بسته‌بندی اصلی، تا ۳ روز قابل بازگشت یا تعویض هستند.",
    },
    {
      title: "حریم خصوصی",
      content:
        "اطلاعات کاربران محرمانه بوده و صرفاً برای پردازش سفارش‌ها استفاده می‌شود.",
    },
    {
      title: "مالکیت معنوی",
      content:
        "تمامی محتوا و تصاویر سایت متعلق به یانگ است و هرگونه استفاده غیرمجاز پیگرد قانونی دارد.",
    },
    {
      title: "پشتیبانی",
      content:
        "تیم پشتیبانی از طریق ایمیل و شبکه‌های اجتماعی در روزهای کاری پاسخگوی شماست.",
    },
  ];

  const ppBannerData = [
    {
      img: ppImage,
      title: " قوانین و مقررات ",
    },
  ];

  return (
    <div className="pp-page">
      <IntroBanner cat={ppBannerData[0]} TitleclassName="pp-title" />
      <div className="container">
        <div className="pp-page-content-wrapper">
          <div className="pp-long-text-box">
            {ppTextData.map((item, index) => (
              <div key={index} className="pp-long-text">
                <h4>{item.title}</h4>
                <p>{item.content}</p>
              </div>
            ))}
          </div>
          {/* <div className="pp-short-text-box">
            <h4>هر چی مخیوای بپرس</h4>
            <ul className="pp-short-text-box-list">
              {ppTextData.map((item, index) => (
                <li key={index}>{item.title}</li>
              ))}
            </ul>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;
